import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useRefcodeLookup(refcode: string | null | undefined) {
  return useQuery({
    queryKey: ["refcode-lookup", refcode],
    queryFn: async () => {
      if (!refcode) return null;
      const { data, error } = await api.referrer.byRefcode({ refcode }).get();
      if (error) throw error;
      return data;
    },
    enabled: !!refcode,
    staleTime: 60000, // Cache for 1 minute
  });
}
